import React, { Suspense, useEffect, useRef } from "react";
import { ICreateComponentSuspenseOptions, ICreateInitial } from "./type";
import LoadingSquare from "./Components/LoadingSquare";

function generateUID() {
    return 'uid-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 5);
}
export const MountComponent = (props: { initial: ICreateInitial, className?: string }) => {
    const { initial } = props
    const id = useRef(generateUID())
    useEffect(() => {
        initial.mount('#' + id.current)
        return () => {
            initial.unmount()
        }
    }, [])
    return <div id={id.current} className={props.className} />
}
export const CreateMountComponent = (initial: ICreateInitial) => {
    const Component = (props: any) => {
        return <MountComponent {...props} initial={initial} />
    }
    return Component
}
// import('LayoutReact/App1').
export const CreateComponent = (loading: Promise<any>) => {
    const Comp = React.lazy(() => loading.then((module) => {
        return { default: CreateMountComponent(module.default) };
    }));
    return Comp
}
export const CreateComponentLazy = CreateComponent



export const CreateComponentSuspense = function <TProps extends { className?: string }>(loading: Promise<any>, options?: ICreateComponentSuspenseOptions) {
    const Comp = React.lazy(() => loading.then((module) => {
        return { default: CreateMountComponent(module.default) };
    }).catch(err => {
        console.error(err);
        return { default: () => <div>Error...</div> }
    }));
    let LoadingComponent = options?.LoadingComponent
    if (!LoadingComponent) {
        LoadingComponent = LoadingSquare
    }
    return (props: TProps) => <Suspense fallback={<LoadingComponent />}>
        <Comp {...props} className={options?.className ?? props.className ?? "mfe-module-mount"} />
    </Suspense>
}